import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-mydocuments",
  templateUrl: "./mydocuments.component.html",
  styleUrls: ["./mydocuments.scss"],
})
export class MyDocumentsComponent implements OnInit {
  
  tabselector: string;

  ngOnInit(): void {
    this.tabselector = "tabs1";
  }

  tabClick(clickedTab) {
    this.tabselector = clickedTab;
  }
}
